import { ReactElement } from "react";
import { Text } from "@mantine/core";
import { formatPrice, formatQuantity } from "@common/utils/string";
import { NUMBER_FORMAT_PRICE_OPTIONS } from "@common/utils/string/constants";
import UsageGraph from "@components/ui/usage/UsageGraph";
import { IMeteredAddOnUsage } from "../../types";
import { UsageListing } from "./UsageListing";

interface IMeteredAddOnUsageProps {
  dataTestId: string;
  /** what is metered, as the listing names it: "Stored rows" */
  unitLabel: string;
  /** the same unit inside the graph's ceiling: "stored rows" */
  maxUnitLabel: string;
  usage: IMeteredAddOnUsage;
  pricePerUnit: number;
}

/** the usage breakdown every paid metered add-on shows under its manage card */
export function MeteredAddOnUsage({
  dataTestId,
  unitLabel,
  maxUnitLabel,
  usage: { hasQuota, usage, includedUnits, includedUnitsUsed, billableUnits },
  pricePerUnit,
}: IMeteredAddOnUsageProps): ReactElement {
  const pricePer1M = formatPrice(
    1_000_000 * pricePerUnit,
    NUMBER_FORMAT_PRICE_OPTIONS,
  );
  const cost = formatPrice(
    billableUnits * pricePerUnit,
    NUMBER_FORMAT_PRICE_OPTIONS,
  );

  return (
    <>
      {billableUnits === 0 && (
        <UsageGraph
          hasQuota={hasQuota}
          usage={includedUnitsUsed}
          prepaidUnits={includedUnits}
          metricLabel="Included usage"
          maxLabel={`${formatQuantity(includedUnits)} ${maxUnitLabel}`}
        />
      )}

      <UsageListing
        dataTestId={dataTestId}
        periodLabel="Current billing period"
        rowLabel={`${unitLabel} (${pricePer1M} per 1M, ${formatQuantity(includedUnits)} free)`}
        value={usage}
      >
        <Text fw={700} fz="sm" ta="right" w="100%">
          Cost: {cost}
        </Text>
      </UsageListing>
    </>
  );
}
